// extracted by mini-css-extract-plugin
export default {"container":"item_container__GXuoM","duration":"item_duration__yxEg7","careerName":"item_careerName__Q3zZi","careerLevel":"item_careerLevel__pSfrg"};